import Question, { QuestionsContainer, QuestionWrapper } from 'components/reports/Question'
import OutputDetails from 'components/reports/OutputDetails'
import ReferrableQuestionWrapper from 'components/reports/ReferrableQuestionWrapper'
import { formatDateMonthYear } from 'hooks/useDateUtils'

export default function TgcmDetails({ data }) {

    var questions = data.conditionSpecific.questions

    return (
        <>
            <h3>Tumour/Growth/Cyst/Mole Specific Questions</h3>

            <QuestionsContainer>

                <QuestionWrapper number='1'>
                    <Question>Please provide exact diagnosis to include type, size and site of tumour/lesion(s):</Question>
                    <ReferrableQuestionWrapper isReferred={questions.exactDiagnosis.referToAttachments}>
                        <p>{questions.exactDiagnosis.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='2'>
                    <Question>Please confirm the date of diagnosis and presenting symptoms:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.diagnosisDetails.referToAttachments}>
                        <Question>Date of Diagnosis:</Question>
                        <p>{formatDateMonthYear(questions.diagnosisDetails.subQuestions.dateOfDiagnosis)}</p>

                        <Question>Presenting symptoms:</Question>
                        <p>{questions.diagnosisDetails.subQuestions.presentingSymptoms}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='3'>
                    <Question>Please provide the date and results of any investigations:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.investigations.referToAttachments}>
                        <OutputDetails
                            details={questions.investigations.details}
                        />
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='4'>
                    <Question>Was treatment provided to the patient?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.treatmentProvided.referToAttachments}>
                        <p>{questions.treatmentProvided.value}</p>
                        {questions.treatmentProvided.value === 'Yes' && (
                            <>
                                <Question>If yes, please give details of treatment:</Question>
                                <p>{questions.treatmentProvided.subQuestions.details}</p>

                                <Question>Treatment Start Date:</Question>
                                <p>{formatDateMonthYear(questions.treatmentProvided.subQuestions.dateStarted)}</p>

                                <Question>Treatment End Date:</Question>
                                <p>{formatDateMonthYear(questions.treatmentProvided.subQuestions.dateEnded)}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='5'>
                    <Question>Are there are any complications or ongoing issues?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyComplicationsOngoing.referToAttachments}>
                        <p>{questions.anyComplicationsOngoing.value}</p>
                        {questions.anyComplicationsOngoing.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details:</Question>
                                <p>{questions.anyComplicationsOngoing.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='6'>
                    <Question>Are there any other factors or co-morbidities present which may influence the prognosis of this condition?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyOtherFactors.referToAttachments}>
                        <p>{questions.anyOtherFactors.value}</p>
                        {questions.anyOtherFactors.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details:</Question>
                                <p>{questions.anyOtherFactors.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

            </QuestionsContainer>
        </>
    )
}